import { useQuery } from '@apollo/client';
import { graphql } from '../gql';
import { IQueryGetEntitiesFieldArgs } from './types';
import { useMemo } from 'react';
import {
  getFirstPaginatedNode,
  getPaginatedNodes,
  getPaginationTotalResults,
} from './utils';

export const GET_ENTITIES_DOMAINS = graphql(`
  query getDomains($uuid: String) {
    entities(filters: { submissionUuid: $uuid, submissionType: INSURED }) {
      edges {
        cursor
        node {
          domains {
            pageInfo {
              totalResults
              pageNumber
              pageSize
              hasNextPage
              hasPreviousPage
            }
            edges {
              cursor
              node {
                uuid
                domain
                dkim
                spf
                subDomains {
                  pageInfo {
                    totalResults
                  }
                  edges {
                    cursor
                    node {
                      uuid
                      dmarc
                      name
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`);

export function useGetEntitiesDomainsQuery({
  submissionUuid,
}: IQueryGetEntitiesFieldArgs) {
  const { loading, error, data } = useQuery(GET_ENTITIES_DOMAINS, {
    variables: {
      uuid: submissionUuid,
    },
  });

  const { domains, totalDomains } = useMemo(() => {
    if (loading) {
      return {
        domains: [],
        totalDomains: 0,
      };
    }
    const entity = getFirstPaginatedNode(data?.entities);
    return {
      domains: getPaginatedNodes(entity?.domains),
      totalDomains: getPaginationTotalResults(entity?.domains) ?? 0,
    };
  }, [data, loading]);

  return {
    loading,
    error,
    data,
    domains,
    totalDomains,
  };
}
